module.exports = __webpack_public_path__ + "static/media/fu.49f7780f.png";